module.exports = __webpack_public_path__ + "static/media/09n.a3252874.png";